function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13 3l1.734 4.509c.282.733.423 1.1.643 1.408a3 3 0 00.706.707c.308.219.675.36 1.408.642L22 12l-4.509 1.734c-.733.282-1.1.423-1.408.643a2.999 2.999 0 00-.706.706c-.22.308-.36.675-.643 1.408L13 21l-1.734-4.509c-.282-.733-.423-1.1-.643-1.408a2.998 2.998 0 00-.706-.707c-.308-.219-.675-.36-1.408-.642L4 12l4.509-1.734c.733-.282 1.1-.423 1.408-.642a3 3 0 00.707-.707c.219-.308.36-.675.642-1.408L13 3z",
  fill: "#7042CC"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.5 22v-5m0-10V2M2 4.5h5m-5 15h5M13 3l-1.734 4.509c-.282.733-.423 1.1-.643 1.408a3 3 0 01-.706.707c-.308.219-.675.36-1.408.642L4 12l4.509 1.734c.733.282 1.1.423 1.408.643.273.194.512.433.707.706.219.308.36.675.642 1.408L13 21l1.734-4.509c.282-.733.423-1.1.643-1.408.194-.273.433-.512.706-.707.308-.219.675-.36 1.408-.642L22 12l-4.509-1.734c-.733-.282-1.1-.423-1.408-.642a3 3 0 01-.706-.707c-.22-.308-.36-.675-.643-1.408L13 3z",
  stroke: "#7042CC",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgStarAi = function SvgStarAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgStarAi;